export const HomeBannerList = 'yhPCHomeBanner' // 首页轮播

export const HomeImageNavList = 'yhPCHomeImageNav' // 首页图片导航

export const CHESS_BANNER = 'yhPcChessBanner' // 游戏页面
export const FISH_BANNER = 'yhPcFishBanner' // 游戏页面
export const SLOT_BANNER = 'yhPcSlotBanner' // 游戏页面
export const SLOT_HOT_BANNER = 'yhPcSlotHotBanner' // 电子内页Hot
export const LIVE_BANNER = 'yhPcLiveBanner' // 游戏页面
export const SPORTS_BANNER = 'yhPcSportsBanner' // 游戏页面
export const LOTTERY_BANNER = 'yhPcLotteryBanner' // 游戏页面

export const DISCOUNTS_BANNER = 'yhPcDiscountBanner' // 优惠页面

export const VIP_BANNER = 'yhPcVipBanner' // VIP页面

export const MINE_BANNER = 'yhPcMemberCenterBanner' // 我的
// 挂件
export const PENDANT_LEFT = 'yhPCPendantLeft' // 左边挂件
export const PENDANT_RIGHT = 'yhPCPendantRight' // 右边挂件
export const PENDANT_TOP_LEFT = 'yhPCPendantTopLeft' // 左上边挂件
export const PENDANT_TOP_RIGHT = 'yhPCPendantTopRight' // 右上边挂件
export const PENDANT_BOTTOM_LEFT = 'yhPCPendantBottomLeft' // 左下边挂件
export const PENDANT_BOTTOM_RIGHT = 'yhPCPendantBottomRight' // 右下边挂件
export const PENDANT_HOME_CENTER = 'yhPCPendantCenter' // 首页中间弹窗

export const PENDANT_CRICKET_BANNER = 'yhPCCRICKETBANNER' // 板球bannaer

export const PENDANT_TEAM_VIDEO = 'pcTeamVideo' // 团队中的 视频

export const Featured_BANNER = 'Featured' // Featured

export const IC_Index_Center_BANNER = 'PCHomeBanner' // Featured

export const affiliate_BANNER = 'PCAffiliates' // affiliate_BANNER





// WEBPACK FOOTER //
// ./src/pages/build901/assets/js/bannerCode.js